import { isEqual, uniqWith } from "lodash";
import type { EventFieldset } from "@searchui-searchforms/shared/form-metadata";
import { getEventInstancesPath } from "@/entities/data-model/@x/form-metadata";
import type { EventIdentity } from "@/entities/data-model/@x/form-metadata";

/**
 * Identity is read from the fields only — the fieldset's own `relation`/`eventType` is the deprecated pre-field-identity spelling and must not be read.
 * A fieldset with no fields yields no identities, so seeding, padding, and the classic renderers all agree on rendering nothing for it.
 */
export const getRowEventIdentities = ({ fields }: Pick<EventFieldset, "fields">): EventIdentity[] =>
    uniqWith(
        fields.map(({ relation, eventType }): EventIdentity => ({ relation, eventType })),
        isEqual,
    );

export const getRowInstancesPaths = (row: Pick<EventFieldset, "fields">): string[] =>
    getRowEventIdentities(row).map(getEventInstancesPath);
